// source: pbtypes/tools/cloud_config/overrides.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var google_protobuf_struct_pb = require('google-protobuf/google/protobuf/struct_pb.js');
goog.object.extend(proto, google_protobuf_struct_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var pbtypes_tools_overrides_typed_overrides_pb = require('../../../pbtypes/tools/overrides/typed_overrides_pb.js');
goog.object.extend(proto, pbtypes_tools_overrides_typed_overrides_pb);
goog.exportSymbol('proto.cloud_config.Overrides', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud_config.Overrides = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud_config.Overrides, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud_config.Overrides.displayName = 'proto.cloud_config.Overrides';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud_config.Overrides.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud_config.Overrides.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud_config.Overrides} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_config.Overrides.toObject = function(includeInstance, msg) {
  var f, obj = {
overrides: (f = msg.getOverrides()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f),
lastUpdatedAt: (f = msg.getLastUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
typedOverrides: (f = msg.getTypedOverrides()) && pbtypes_tools_overrides_typed_overrides_pb.TypedOverrides.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud_config.Overrides}
 */
proto.cloud_config.Overrides.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud_config.Overrides;
  return proto.cloud_config.Overrides.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud_config.Overrides} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud_config.Overrides}
 */
proto.cloud_config.Overrides.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setOverrides(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastUpdatedAt(value);
      break;
    case 3:
      var value = new pbtypes_tools_overrides_typed_overrides_pb.TypedOverrides;
      reader.readMessage(value,pbtypes_tools_overrides_typed_overrides_pb.TypedOverrides.deserializeBinaryFromReader);
      msg.setTypedOverrides(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud_config.Overrides.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud_config.Overrides.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud_config.Overrides} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_config.Overrides.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOverrides();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
  f = message.getLastUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTypedOverrides();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      pbtypes_tools_overrides_typed_overrides_pb.TypedOverrides.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Struct overrides = 1;
 * @return {?proto.google.protobuf.Struct}
 */
proto.cloud_config.Overrides.prototype.getOverrides = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 1));
};


/**
 * @param {?proto.google.protobuf.Struct|undefined} value
 * @return {!proto.cloud_config.Overrides} returns this
*/
proto.cloud_config.Overrides.prototype.setOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud_config.Overrides} returns this
 */
proto.cloud_config.Overrides.prototype.clearOverrides = function() {
  return this.setOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud_config.Overrides.prototype.hasOverrides = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp last_updated_at = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.cloud_config.Overrides.prototype.getLastUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.cloud_config.Overrides} returns this
*/
proto.cloud_config.Overrides.prototype.setLastUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud_config.Overrides} returns this
 */
proto.cloud_config.Overrides.prototype.clearLastUpdatedAt = function() {
  return this.setLastUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud_config.Overrides.prototype.hasLastUpdatedAt = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional overrides.TypedOverrides typed_overrides = 3;
 * @return {?proto.overrides.TypedOverrides}
 */
proto.cloud_config.Overrides.prototype.getTypedOverrides = function() {
  return /** @type{?proto.overrides.TypedOverrides} */ (
    jspb.Message.getWrapperField(this, pbtypes_tools_overrides_typed_overrides_pb.TypedOverrides, 3));
};


/**
 * @param {?proto.overrides.TypedOverrides|undefined} value
 * @return {!proto.cloud_config.Overrides} returns this
*/
proto.cloud_config.Overrides.prototype.setTypedOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud_config.Overrides} returns this
 */
proto.cloud_config.Overrides.prototype.clearTypedOverrides = function() {
  return this.setTypedOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud_config.Overrides.prototype.hasTypedOverrides = function() {
  return jspb.Message.getField(this, 3) != null;
};


goog.object.extend(exports, proto.cloud_config);
